// extracted by mini-css-extract-plugin
export var body = "_f9-8";
export var button = "_f9-0";
export var closeButton = "_f9-5";
export var content = "_f9-3";
export var empty = "_f9-f";
export var grid = "_f9-c";
export var header = "_f9-4";
export var icon = "_f9-1";
export var option = "_f9-d";
export var optionSelected = "_f9-e";
export var overlay = "_f9-2";
export var searchIcon = "_f9-a";
export var searchInput = "_f9-b";
export var searchWrapper = "_f9-9";
export var title = "_f9-6";
export var visuallyHidden = "_f9-7";